export default __webpack_public_path__ + "static/logo-2275f20beecd70afbdbbc45626ae0607.svg";